import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const blockDriver = async (id: string, blocked: boolean) => {
  let res = await apiManager.patch(`/admin/driver/${id}/modify`, {
    isBlocked: blocked,
  });
  return res;
};

export const useBlockDriver = () =>
  useMutation({
    mutationFn: async ({ id, blocked }: { id: string; blocked: boolean }) => {
      const res = await apiClient.patch(ENDPOINTS.DRIVER.BLOCK_DRIVER(id), { isBlocked: blocked });
      return res.data;
    },
  });